import { css } from "@emotion/react";

export function alertsBellCSS() {
    return css`
        position: relative;
        display: inline-flex;
        align-items: center;
        font-family: 'Neue Haas Grotesk Display Pro', -apple-system, BlinkMacSystemFont,
            'Segoe UI', Roboto, Helvetica, Arial, sans-serif;

        @keyframes ab-fade-in {
            from { opacity: 0; transform: translateY(-4px); }
            to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes ab-pulse {
            0%, 100% { box-shadow: 0 0 0 0 rgba(229, 57, 53, 0.45); }
            50%      { box-shadow: 0 0 0 4px rgba(229, 57, 53, 0); }
        }

        .ab-trigger {
            background: #f1f5f9;
            border: 1px solid #e2e8f0;
            cursor: pointer;
            position: relative;
            width: 40px;
            height: 40px;
            color: #1A9AC4;
            font-size: 1.25rem;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border-radius: 10px;
            transition: all 160ms ease;
        }
        .ab-trigger:hover {
            background: #e0f2fe;
            color: #00BA6E;
            border-color: #34C6F1;
            transform: translateY(-1px);
        }
        .ab-trigger.active {
            background: #e0f2fe;
            color: #1A9AC4;
            border-color: #34C6F1;
            box-shadow: 0 0 0 3px rgba(52, 198, 241, 0.18);
        }
        .ab-trigger.has-alerts {
            color: #00BA6E;
        }
        .ab-trigger.has-alerts:hover {
            color: #00BA6E;
        }

        .ab-badge {
            position: absolute;
            top: -6px;
            right: -6px;
            background: #E53935;
            color: #fff;
            border-radius: 999px;
            font-size: 0.7rem;
            min-width: 20px;
            height: 20px;
            line-height: 18px;
            text-align: center;
            padding: 0 5px;
            font-weight: 800;
            letter-spacing: 0.02em;
            border: 2px solid #fff;
            box-sizing: content-box;
            animation: ab-pulse 1.8s ease-in-out infinite;
            box-shadow: 0 2px 4px rgba(229, 57, 53, 0.35);
        }

        .ab-dropdown {
            position: absolute;
            right: 0;
            top: calc(100% + 8px);
            width: 360px;
            background: #fff;
            box-shadow: 0 16px 40px rgba(15, 23, 42, 0.18);
            border-radius: 14px;
            border: 1px solid #e2e8f0;
            z-index: 9999;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            animation: ab-fade-in 180ms ease-out;
        }

        @media (max-width: 650px) {
            .ab-dropdown {
                width: calc(100vw - 24px);
                right: -8px;
            }
        }

        .ab-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 12px 14px;
            border-bottom: 1px solid #e2e8f0;
            background: #f8fafc;
        }
        .ab-header-title {
            display: flex;
            align-items: center;
            gap: 8px;
        }
        .ab-header-title .ico {
            width: 26px;
            height: 26px;
            border-radius: 7px;
            background: linear-gradient(135deg, #34C6F1, #00BA6E);
            color: #fff;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-size: 0.8rem;
        }
        .ab-header-title strong {
            color: #0f172a;
            font-size: 0.88rem;
            letter-spacing: 0.02em;
        }
        .ab-header-actions {
            display: flex;
            gap: 2px;
        }
        .ab-icon-btn {
            background: transparent;
            border: none;
            cursor: pointer;
            width: 28px;
            height: 28px;
            border-radius: 7px;
            color: #1A9AC4;
            font-size: 0.85rem;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            transition: background 140ms ease;
        }
        .ab-icon-btn:hover { background: #e0f2fe; }
        .ab-icon-btn:disabled { opacity: 0.55; cursor: not-allowed; }

        .ab-list {
            max-height: 360px;
            overflow-y: auto;
            background: #fafbfc;
        }
        .ab-list::-webkit-scrollbar { width: 6px; }
        .ab-list::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 6px; }

        .ab-card {
            position: relative;
            display: flex;
            gap: 10px;
            padding: 10px 12px 10px 12px;
            border-bottom: 1px solid #eef2f6;
            border-left: 3px solid var(--sev-border, #34C6F1);
            background: #fff;
            cursor: pointer;
            transition: background 160ms ease;
        }
        .ab-card:hover { background: #f8fafc; }
        .ab-card.unseen { background: #fbfeff; }
        .ab-card.unseen::after {
            content: '';
            position: absolute;
            top: 14px;
            right: 12px;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: #34C6F1;
            box-shadow: 0 0 0 3px rgba(52, 198, 241, 0.18);
        }

        .ab-card-icon {
            width: 30px;
            height: 30px;
            border-radius: 8px;
            background: var(--sev-bg, #e0f2fe);
            color: var(--sev-fg, #075985);
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-size: 0.85rem;
            flex-shrink: 0;
        }

        .ab-card-body {
            flex: 1;
            min-width: 0;
        }
        .ab-card-title {
            font-size: 0.82rem;
            font-weight: 600;
            color: #0f172a;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            padding-right: 14px;
        }
        .ab-card-message {
            font-size: 0.72rem;
            color: #64748b;
            margin-top: 2px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
        }
        .ab-card-meta {
            display: flex;
            align-items: center;
            gap: 6px;
            margin-top: 4px;
            font-size: 0.65rem;
            color: #94a3b8;
            letter-spacing: 0.02em;
        }
        .ab-card-meta .sep {
            width: 3px;
            height: 3px;
            border-radius: 50%;
            background: #cbd5e1;
            display: inline-block;
        }
        .ab-card-meta .status-chip {
            display: inline-flex;
            padding: 1px 6px;
            border-radius: 999px;
            font-size: 0.6rem;
            font-weight: 600;
            background: #f1f5f9;
            color: #475569;
            text-transform: uppercase;
            letter-spacing: 0.04em;
        }
        .ab-card-meta .status-chip.silenced { background: #fef3c7; color: #92400e; }
        .ab-card-meta .status-chip.ignored  { background: #e2e8f0; color: #475569; }
        .ab-card-meta .status-chip.resolved { background: #dcfce7; color: #166534; }
        .ab-card-meta .status-chip.open     { background: #e0f2fe; color: #075985; }

        .ab-card-actions {
            display: flex;
            gap: 4px;
            margin-top: 8px;
        }
        .ab-action-btn {
            background: transparent;
            border: 1px solid #e2e8f0;
            border-radius: 7px;
            width: 26px;
            height: 26px;
            cursor: pointer;
            font-size: 0.75rem;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            color: #64748b;
            transition: all 140ms ease;
        }
        .ab-action-btn:hover { background: #f1f5f9; }
        .ab-action-btn:disabled { cursor: progress; opacity: 0.75; }
        .ab-card.busy { pointer-events: none; opacity: 0.85; }
        .ab-card.busy .ab-card-actions { pointer-events: auto; }
        .ab-action-btn.ignore:hover {
            background: #f1f5f9;
            border-color: #cbd5e1;
            color: #475569;
        }
        .ab-action-btn.silence:hover {
            background: #fef3c7;
            border-color: #f59e0b;
            color: #92400e;
        }
        .ab-action-btn.resolve:hover {
            background: #dcfce7;
            border-color: #22EC9A;
            color: #166534;
        }

        .ab-empty {
            padding: 28px 16px;
            text-align: center;
        }
        .ab-empty-icon {
            font-size: 1.8rem;
            color: #00BA6E;
            margin-bottom: 6px;
        }
        .ab-empty-title {
            font-size: 0.82rem;
            font-weight: 700;
            color: #0f172a;
            margin: 0 0 2px;
        }
        .ab-empty-sub {
            font-size: 0.72rem;
            color: #94a3b8;
            margin: 0;
        }

        .ab-footer-btn {
            width: 100%;
            padding: 10px 14px;
            background: #f8fafc;
            border: none;
            border-top: 1px solid #e2e8f0;
            cursor: pointer;
            color: #00BA6E;
            font-weight: 700;
            font-size: 0.8rem;
            letter-spacing: 0.02em;
            font-family: inherit;
            transition: background 140ms ease;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
        }
        .ab-footer-btn:hover {
            background: #ecfdf5;
            color: #00a35d;
        }
    `;
}
